export var OauthProvider;
(function (OauthProvider) {
    OauthProvider["Kameleoon"] = "kameleoon";
    OauthProvider["Slack"] = "slack";
    OauthProvider["Microsoft"] = "microsoft";
})(OauthProvider || (OauthProvider = {}));
//# sourceMappingURL=oauth-providers.js.map